import * as React from 'react';
import { Bulit16, IpotekaSoldier16 } from '@cian/ui-kit';
import { EPromoType } from '../types/newbuilding/promos';

export const QUANTITY_PROMOS_IN_ROW = 3;

export const BANK_ICON_MAP: { [key: string]: React.ReactNode } = {
  [EPromoType.MaternalCapital]: <Bulit16 color="gray_icons_100" />,
  [EPromoType.MilitaryMortgage]: <IpotekaSoldier16 color="success_100" />,
};
